import styled, { css } from "styled-components";

interface StyledSpanProps {
  color?: string;
  fontSize?: string;
  weight?: "normal" | "500" | "300" | "bold" | "700" | "400" | "800";
  direction?: "rtl" | "ltr";
  alignItem?: string;
  alignText?: string;
  customStyle?: string;
  lineHeight?: string;
  margin?: string;
}
const StyledSpan = styled.span<StyledSpanProps>`
  font-style: normal;
  line-height: ${(p: any) => (p.lineHeight ? p.lineHeight : "22px")};
  font-weight: ${(p: any) => (p.weight ? p.weight : "normal")};
  font-size: ${(p: any) => (p.fontSize ? p.fontSize : "14px")};
  align-items: ${(p: any) => (p.alignItem ? p.alignItem : "center")};
  text-align: ${(p: any) => (p.alignText ? p.alignText : "start")};
  direction: ${(p: any) => (p.direction ? p.direction : "auto")};
  margin: ${(p: any) => (p.margin ? p.margin : "0")};
  color: ${(p: any) => (theme: any) =>
    p.color ? theme.theme[p.color] : theme.theme.white };
  ${(props: StyledSpanProps) =>
    props.customStyle &&
    css`
      ${props.customStyle}
    `}
`;

export default StyledSpan;
